<template>
  <div class="content Tabs">

     <b-tabs card>

          <b-tab :title="lang.tab_NewPart"  :title-link-class="textColors" :title-item-class="textColors" active >
            <!-- <div v-if="isPlugin">
              <CategoryComponent  :lang="lang.PluginCategory"></CategoryComponent>

            </div> -->
            <NewProjectFormComponent :lang="lang.NewProjectForm"></NewProjectFormComponent>
            <!-- <FoldersTreeComponent :lang="lang.FolderTree" isCategory="edit"></FoldersTreeComponent>   -->
          </b-tab>

        </b-tabs>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'
//import vSelect from 'vue-select'


import NewProjectFormComponent from '@/components/shared/NewProjectFormComponent'
import FoldersTreeComponent from '@/components/shared/FoldersTreeComponent'

export default {
  name: "Content",
  components: {
    NewProjectFormComponent,
    FoldersTreeComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {


  },
  updated() {


  },
  watch: {

  }
}
</script>

<style scooped>

  #NewProjectFormComponent{
    width: 60%;
  }

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectNew/Middle/Content/Content.vue